// import './utils/vconsole'
import './utils/initFontBaseUrl'  // 初始化字体 CSS 变量
import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import "./styles/index.less";
import App from "./App";
import "./i18n";
import { getWxCodeFromUrl } from "./utils"
import { AliveScope } from 'react-activation'
import ReactDOM from 'react-dom/client';
import { initSystemFontSize } from './utils/systemFontSize';

// 在渲染前存储wxcode，小程序环境用于静默登录
const storeWxCodeFromUrl = () => {
  const wxcode = getWxCodeFromUrl();
  if (wxcode) {
    localStorage.setItem("wxcode", wxcode);
  }
};
// 执行存储逻辑
storeWxCodeFromUrl();

// 初始化系统文字大小
initSystemFontSize()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// 把最外层<React.StrictMode>去除了，<AliveScope>明确表示不要用<React.StrictMode>
root.render(
<BrowserRouter>
  <Suspense>
    <AliveScope>
      <App />
    </AliveScope>
  </Suspense>
</BrowserRouter>
);
